import { forwardRef } from "react";

import HeaderButton from "./header-button";
import DetailsBox from "../details-box";
import { Accordion, Accordions } from "@monta/design-system";

import type { TAccordionRef } from "@monta/design-system";
import type { DetailsAccordionProps } from "./types";

const DetailsAccordion = forwardRef<TAccordionRef, DetailsAccordionProps>(
  (
    { title, status, items, correct, inCorrect, noAnswers, total, defaultOpen },
    ref
  ) => {
    return (
      <Accordions>
        <Accordion
          ref={ref}
          label={title}
          defaultOpen={defaultOpen}
          button={<HeaderButton status={status} />}
        >
          <DetailsBox
            items={items}
            correct={correct}
            inCorrect={inCorrect}
            noAnswers={noAnswers}
            total={total}
          />
        </Accordion>
      </Accordions>
    );
  }
);

DetailsAccordion.displayName = "DetailsAccordion";

export default DetailsAccordion;
